import http from "@/utils/request";

// 参数接口
export interface SelectCmsShareholderGroupPageParams {
  groupName?: string;
  ypageNum?: number;
  ypageSize?: number;
}

// 响应接口
export interface SelectCmsShareholderGroupPageRes {
  code: number;
  msg: string;
  pageNum: number;
  pageSize: number;
  rows: {
    createBy: string;
    createTime: Record<string, unknown>;
    delFlag: string;
    groupName: string;
    id: number;
    remark: string;
    updateBy: string;
    updateTime: Record<string, unknown>;
  }[];
  total: number;
}

/** 
 * 股东分组列表分页查询
 * @param {object} params req
 * @param {string} params.groupName 股东分组名称
 * @param {number} params.ypageNum 
 * @param {number} params.ypageSize 
 * @returns
 */
export function selectCmsShareholderGroupPage(params: SelectCmsShareholderGroupPageParams): Promise<SelectCmsShareholderGroupPageRes> {
  return http.post(`/shareholder/group/list`, params);
}

// 参数接口
export interface AddShareholderGroupParams {
  groupName?: string;
  id?: number;
  remark?: string;
}

// 响应接口
export interface AddShareholderGroupRes {
  code: number;
  data: string;
  msg: string;
}

/** 
 * 股东分组新增
 * @param {object} params req
 * @param {string} params.groupName 分组名称
 * @param {number} params.id ID
 * @param {string} params.remark 备注
 * @returns
 */
export function addShareholderGroup(params: AddShareholderGroupParams): Promise<AddShareholderGroupRes> {
  return http.post(`/shareholder/group/add`, params);
}

// 响应接口
export interface DeleteShareholderGroupRes {
  code: number;
  data: string;
  msg: string;
}

/** 
 * 股东分组删除
 * @param {string} id id
  * @returns
 */
export function deleteShareholderGroup(id: number): Promise<DeleteShareholderGroupRes> {
  return http.post(`/shareholder/group/delete/${id}`);
}

// 响应接口
export interface SelectCmsShareholderGroupDetailRes {
  code: number;
  data: {
    createBy: string;
    createTime: Record<string, unknown>;
    delFlag: string;
    groupName: string;
    id: number;
    remark: string;
    updateBy: string;
    updateTime: Record<string, unknown>;
  };
  msg: string;
}

/** 
 * 股东分组详情
 * @param {string} id id
  * @returns
 */
export function selectCmsShareholderGroupDetail(id: number): Promise<SelectCmsShareholderGroupDetailRes> {
  return http.get(`/shareholder/group/detail/${id}`);
}

// 参数接口
export interface EditShareholderGroupParams {
  groupName?: string;
  id?: number;
  remark?: string;
}

// 响应接口
export interface EditShareholderGroupRes {
  code: number;
  data: string;
  msg: string;
}

/** 
 * 股东分组修改
 * @param {object} params req
 * @param {string} params.groupName 分组名称
 * @param {number} params.id ID
 * @param {string} params.remark 备注
 * @returns
 */
export function editShareholderGroup(params: EditShareholderGroupParams): Promise<EditShareholderGroupRes> {
  return http.post(`/shareholder/group/edit`, params);
}

// 参数接口
export interface EditShareholderGroupAmountParams {
  accountTrend?: string;
  accountType?: string;
  amount?: number;
  id?: number;
}

// 响应接口
export interface EditShareholderGroupAmountRes {
  code: number;
  data: string;
  msg: string;
}

/** 
 * 股东金额增减
 * @param {object} params req
 * @param {string} params.accountTrend 类型,1:赚取，2消耗/扣减
 * @param {string} params.accountType 类型,1:金额，2积分,3:转增金额,4充电收益,5代理商收益，6.充电代理商收益，7渠道收益
 * @param {number} params.amount 数额
 * @param {number} params.id 股东分组ID
 * @returns
 */
export function editShareholderGroupAmount(params: EditShareholderGroupAmountParams): Promise<EditShareholderGroupAmountRes> {
  return http.post(`/shareholder/group/editShareholderGroupAmount`, params);
}

// 参数接口
export interface SelectCmsShareholderGroupUserPageParams {
  groupId?: number;
  mobile?: string;
  userBusinessId?: string;
  ypageNum?: number;
  ypageSize?: number;
}

// 响应接口
export interface SelectCmsShareholderGroupUserPageRes {
  code: number;
  msg: string;
  pageNum: number;
  pageSize: number;
  rows: {
    groupId: number;
    groupName: string;
    groupRemark: string;
    id: number;
    mobile: string;
    nickName: string;
    userBusinessId: string;
    userId: number;
    userLevel: string;
  }[];
  total: number;
}

/** 
 * 股东分组成员列表分页查询
 * @param {object} params req
 * @param {number} params.groupId groupId
 * @param {string} params.mobile 手机号
 * @param {string} params.userBusinessId 用户业务ID
 * @param {number} params.ypageNum 
 * @param {number} params.ypageSize 
 * @returns
 */
export function selectCmsShareholderGroupUserPage(params: SelectCmsShareholderGroupUserPageParams): Promise<SelectCmsShareholderGroupUserPageRes> {
  return http.post(`/shareholder/group/user/list`, params);
}

// 响应接口
export interface DeleteShareholderGroupUserRes {
  code: number;
  data: string;
  msg: string;
}

/** 
 * 股东分组成员删除
 * @param {string} id id
  * @returns
 */
export function deleteShareholderGroupUser(id: number): Promise<DeleteShareholderGroupUserRes> {
  return http.post(`/shareholder/group/user/delete/${id}`);
}

// 参数接口
export interface AddShareholderGroupUserParams {
  groupId?: string;
  userId?: string;
}

// 响应接口
export interface AddShareholderGroupUserRes {
  code: number;
  data: string;
  msg: string;
}

/** 
 * 股东分组成员新增
 * @param {object} params req
 * @param {string} params.groupId 分组ID
 * @param {string} params.userId 用户ID
 * @returns
 */
export function addShareholderGroupUser(params: AddShareholderGroupUserParams): Promise<AddShareholderGroupUserRes> {
  return http.post(`/shareholder/group/user/add`, params);
}
